import type { SVGProps } from 'react';
const SvgEventSeat = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="0.75em"
    height="0.75em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#event_seat_svg__a)">
      <path
        fill="currentColor"
        d="M4 18v3h3v-3h10v3h3v-6H4v3Zm15-8h3v3h-3v-3ZM2 10h3v3H2v-3Zm15 3H7V5c0-1.1.9-2 2-2h6c1.1 0 2 .9 2 2v8Z"
      />
    </g>
    <defs>
      <clipPath id="event_seat_svg__a">
        <path fill="currentColor" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgEventSeat;
